import { render, staticRenderFns } from "./GoogleStreamerBanner.vue?vue&type=template&id=1bc9d5ed&"
import script from "./GoogleStreamerBanner.vue?vue&type=script&lang=js&"
export * from "./GoogleStreamerBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports